import styled from 'styled-components';

export const PartSitesIFrame = styled.iframe`
    width: 100%;
    height: 100vh;
    border: 0;
`;
